import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-744a83d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]
const _hoisted_2 = { class: "industry" }
const _hoisted_3 = { class: "tpl-card-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "info" }

import {onMounted, reactive, watch} from "vue";
import {account} from "@/app/login";
import {ITemplate, cardTags, tagsIndustry} from "@/app/templates/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateCardView',
  props: {
    tpl: {}
  },
  setup(__props: any) {

const props = __props
const info = reactive({industry: '', tagColors: ['success', 'processing', 'error', 'warning']})

onMounted(() => {
  props.tpl.tags.forEach(t => {
    if (Object.keys(tagsIndustry).includes(t)) info.industry = tagsIndustry[t]
  })
})
watch(() => props.tpl.tags, () => {
  props.tpl.tags.forEach(t => {
    if (Object.keys(tagsIndustry).includes(t)) info.industry = tagsIndustry[t]
  })
})

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(account).user?.is_master ? `editor?activity_id=${_ctx.tpl.relation_activity_id}` : `editor?template_id=${_ctx.tpl.template_id}`,
    class: _normalizeClass(["tpl-card", {'off-line': !_ctx.tpl.is_active}])
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("img", {
        alt: _ctx.tpl.title
      }, null, 8, _hoisted_1), [
        [_directive_lazy, _ctx.tpl.poster]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(info.industry), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tpl.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_flex, { class: "tags" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tpl.tags, (t, i) => {
                return (_openBlock(), _createBlock(_component_a_tag, {
                  color: info.tagColors[i],
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(cardTags)[t]), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            shape: "round",
            ghost: "",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(account).user?.is_master ? '编辑模板' : '使用此模板创建活动'), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})